module.exports = __webpack_public_path__ + "img/empty.9810e592.png";